import { render, staticRenderFns } from "./Newslist.vue?vue&type=template&id=7f2e09f4"
import script from "./Newslist.vue?vue&type=script&lang=js"
export * from "./Newslist.vue?vue&type=script&lang=js"
import style0 from "./Newslist.vue?vue&type=style&index=0&id=7f2e09f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports